export var TransferDirection;
(function (TransferDirection) {
    TransferDirection["left"] = "left";
    TransferDirection["right"] = "right";
    TransferDirection["up"] = "up";
    TransferDirection["down"] = "down";
})(TransferDirection || (TransferDirection = {}));
